import { oc } from '@orpc/contract';
import { listCostItemsOutputSchema, removeCostItemInputSchema } from '../schemas/costs.schemas.js';
/** Only an `ESTIMATED` item may be removed; anything the workshop has touched is waived, not deleted. */
export const removeCostItemContract = oc
    .route({
    method: 'DELETE',
    path: '/costs/{id}',
    tags: ['Costs'],
    summary: 'Remove a cost item that has not been started',
})
    .input(removeCostItemInputSchema)
    .output(listCostItemsOutputSchema);
//# sourceMappingURL=remove-cost-item.contract.js.map